<app-loading />

<!-- DEBUG PANEL
<div class="api-debug">
  <div *ngIf="debugErrors.length === 0">
    Nessun errore API
  </div>
  <div *ngFor="let err of debugErrors">
    <p><b>#{{err.id}}</b> - {{err.url}}</p>
    <p>Status: {{err.status}}</p>
    <pre>{{ err.body?.message || err.body | json }}</pre>
    <pre>{{ debugInfo | json }}</pre>
    <hr />
  </div>
</div>-->
<nz-layout role="main">
  <!-- navbar -->
  @if (showNavbar) {
    <app-navbar id="navbar" role="navigation" aria-label="Navigazione principale"></app-navbar>
  }

  <nz-layout>
    <!-- sidebar -->
    @if (isLogged || isPreviewMode) {
      <nz-sider class="sidebar" [(nzCollapsed)]="isCollapsed" [nzWidth]="200" [nzCollapsedWidth]="43" role="navigation" aria-label="Menu laterale">
        <div class="sider-content">
          <app-sidebar [isCollapsed]="isCollapsed"></app-sidebar>
          <div class="collapse">
            <span class="icon-collapse" (click)="toggleCollapsed()" (keydown.enter)="toggleCollapsed()" (keydown.space)="toggleCollapsed(); $event.preventDefault()" nz-icon nzType="step-backward" nzTheme="outline" role="button" tabindex="0" aria-label="Collassa menu laterale"></span>
          </div>
        </div>
      </nz-sider>
    }
    <!-- body -->
    <nz-content id="main-content">
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>

  <!-- footer -->
  @if (showFooter) {
    <app-footer role="contentinfo" aria-label="Footer del sito"></app-footer>
  }
  <!-- Cookie button -->
  <!-- <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>
  Cookie policy div
  <div id="ot-sdk-cookie-policy"></div>-->
</nz-layout>
<app-magnolia-sticky-banner></app-magnolia-sticky-banner>
